import React from 'react';

import {useResolvedTimeZone} from 'Utils/useTimeZone';

import TimezoneAutocomplete from './TimezoneAutocomplete';


/**
 * TimeZoneWidget.js
 * Displays which timezone the appointment is currently in.
 * @param {Object} props
 * @return {ReactElement}
 */
export default function TimeZonePicker(props) {
  const {locked, onChange, sx, value} = props;

  const {indexedOpts, timeZone: valueKey, timeZoneOptions} = useResolvedTimeZone(value);

  const autocompleteValue = React.useMemo(() => {
    return indexedOpts[valueKey];
  }, [indexedOpts, valueKey]);

  return (
    <TimezoneAutocomplete
      sx={sx}
      locked={locked}
      options={timeZoneOptions}
      value={autocompleteValue}
      onChange={(option) => onChange(option.name)}
    />
  );
}

